export default "__VITE_ASSET__Twi0s$hr__"